<template>
  <div class="space-y-4">
    <BookingKpis :kpis="stats?.kpis" :loading="loading" />

    <!-- Upcoming load is the question a host opens a dashboard with, and it
         describes the future rather than the selected window, so it sits on its
         own strip rather than inside the KPI row where the range picker implies
         it should move. -->
    <div v-if="stats?.upcoming" class="flex flex-wrap items-center gap-x-6 gap-y-2 px-4 py-3 rounded-xl bg-blue-50/70 dark:bg-blue-900/15 border border-blue-100 dark:border-blue-900/30">
      <span class="text-xs font-semibold text-blue-900/70 dark:text-blue-200/80 uppercase tracking-wider">Coming up</span>
      <span class="text-sm text-blue-900 dark:text-blue-100">
        <b class="tabular-nums">{{ stats.upcoming.next_7_days }}</b> confirmed in the next 7 days
      </span>
      <span class="text-sm text-blue-900 dark:text-blue-100">
        <b class="tabular-nums">{{ stats.upcoming.next_30_days }}</b> in the next 30
      </span>
    </div>

    <BookingsOverTime :data="stats?.over_time || []" :bucket="stats?.range?.bucket" :loading="loading" />

    <BookingRhythm :cells="stats?.heatmap || []" :zone="stats?.range?.zone" :loading="loading" />

    <div class="grid grid-cols-1 xl:grid-cols-2 gap-4">
      <LeadTimeChart :data="stats?.lead_time || []" :loading="loading" />
      <CancellationCard :data="stats?.cancellations || {}" :loading="loading" />
    </div>

    <div class="grid grid-cols-1 xl:grid-cols-3 gap-4">
      <TopEventsCard :data="stats?.top_events || []" :loading="loading" />
      <TopAttendeesCard :data="stats?.top_attendees || []" :loading="loading" />
      <MeetingLocations :data="stats?.locations || []" :loading="loading" />
    </div>
  </div>
</template>

<script setup>
import BookingKpis from './BookingKpis.vue'
import BookingsOverTime from './BookingsOverTime.vue'
import BookingRhythm from './BookingRhythm.vue'
import LeadTimeChart from './LeadTimeChart.vue'
import CancellationCard from './CancellationCard.vue'
import TopEventsCard from './TopEventsCard.vue'
import TopAttendeesCard from './TopAttendeesCard.vue'
import MeetingLocations from './MeetingLocations.vue'

defineProps({
  stats:   { type: Object, default: null },
  loading: { type: Boolean, default: false },
})
</script>
